export default "__VITE_ASSET__EveR1wQS__"